/**
 * Handles submission for the home contact form with reCAPTCHA v3 support.
 */
export const initHomeContactForm = (): void => {
  const form = document.querySelector<HTMLFormElement>(
    ".app-home-contact-form",
  );
  if (!form) return;

  const ajaxMessageContainer =
    form.querySelector<HTMLDivElement>(".ajax-message");
  if (!ajaxMessageContainer) {
    console.warn("[Home Contact Form] AJAX message container not found.");
    return;
  }

  /**
   * Performs the actual AJAX submission
   */
  const submitForm = async (token?: string) => {
    const submitButton = form.querySelector<HTMLButtonElement>(
      'button[type="submit"]',
    );
    if (!submitButton) return;

    const formData = new FormData(form);
    formData.append("action", "submit_home_contact_form");

    if (window.themeVariables?.homeContactFormNonce) {
      formData.append(
        "homeContactFormNonce",
        window.themeVariables.homeContactFormNonce,
      );
    }

    if (token) {
      formData.append("recaptchaToken", token);
    }

    try {
      const response = await fetch(window.themeVariables!.ajaxUrl, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        ajaxMessageContainer.innerHTML = `<div class="alert alert-success">${result.data.message}</div>`;
        ajaxMessageContainer.classList.add("success");
        form.reset();
      } else {
        ajaxMessageContainer.innerHTML = `<div class="alert alert-danger">${result.data.message}</div>`;
        ajaxMessageContainer.classList.add("error");
      }
    } catch (error) {
      console.error("Home contact form submission error:", error);
      ajaxMessageContainer.innerHTML = `<div class="alert alert-danger">An unexpected error occurred. Please try again.</div>`;
      ajaxMessageContainer.classList.add("error");
    } finally {
      submitButton.disabled = false;
      submitButton.style.opacity = "1";
    }
  };

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const submitButton = form.querySelector<HTMLButtonElement>(
      'button[type="submit"]',
    );
    if (!submitButton) return;

    ajaxMessageContainer.innerHTML = "";
    ajaxMessageContainer.classList.remove("error", "success");
    submitButton.disabled = true;
    submitButton.style.opacity = "0.7";

    const siteKey = window.themeVariables?.recaptchaSiteKey;

    // @ts-ignore: grecaptcha is global from script tag
    if (siteKey && typeof grecaptcha !== "undefined") {
      // @ts-ignore
      grecaptcha.ready(() => {
        // @ts-ignore
        grecaptcha
          .execute(siteKey, { action: "submit_home_contact" })
          .then((token: string) => {
            submitForm(token);
          });
      });
    } else {
      // Fallback
      submitForm();
    }
  });

  console.log("[Forms] Home Contact Form initialized.");
};
